import styled from "styled-components";
import { Field as FormikField, FieldProps } from "formik";
import ErrorMarker from "./ErrorMarker";
import Input from "./Input";
import { spacing } from "../../theme";
import * as React from "react";

export const StyledField = styled.div`
  ${spacing("margin-bottom", 48)}
`;
const StyledSubtitle = styled.div`
  font-size: 14px;
  padding-top: 8px;
`;

type Props = {
  name: string;
  className?: string;
  component?: any;
  placeholderText?: string;
  necessaryFieldText?: string;
  render?: (
    props: FieldProps<any> & { error?: string | null }
  ) => React.ReactNode;
  onChange?: (e: React.ChangeEvent<any>) => void;
  [prop: string]: any;
};

export function Field(props: Props) {
  const {
    name,
    component,
    render,
    className,
    necessaryFieldText,
    ...componentProps
  } = props;

  return (
    <StyledField className={className}>
      <FormikField name={name}>
        {({ field, form }) => {
          const error = form.touched[name] && form.errors[name];
          const Component = component || Input;
          // TODO: workaround; firefox does not set 'touched' properly for custom components
          if (component && !componentProps.onChange) {
            field.onChange = e => {
              form.setFieldTouched(e.target.name, true);
              form.handleChange(e);
            };
          }
          return (
            <>
              {error && <ErrorMarker />}
              {render
                ? render({ field, form, error })
                : Component && (
                    <Component
                      maxLength={5000}
                      {...field}
                      {...componentProps}
                      error={error}
                    />
                  )}
              {necessaryFieldText && (
                <StyledSubtitle>{necessaryFieldText}</StyledSubtitle>
              )}
            </>
          );
        }}
      </FormikField>
    </StyledField>
  );
}

export default StyledField;
